const blog = [
    {
        id: '1',
        title: 'Best Architecture Design',
        thumb:'Architecture',
        screens: '/projects/WhatsApp Image 2025-08-08 at 12.10.45 PM.jpeg',
        description: 'Innovative architectural solutions that blend functionality with aesthetic excellence with our expert team.',
        author: 'Jenefer Willy',
        authorTitle:'Senior Architect',
        create_at: '14 AUG,21',
        blogSingleImg:'/projects/maak-residence-2.jpg', 
        comment:'35',
        blClass:'format-standard-image',
        galleryImg1: '/projects/maak-residence-1.jpg',
        galleryImg2: '/projects/aizel-interior-2.jpg',
    },
    {
        id: '2',
        title: 'Modern Bedrooms Tips',
        thumb:'Interior',
        screens: '/projects/WhatsApp Image 2025-08-08 at 12.10.44 PM.jpeg',
        description: 'Transform your bedroom into a luxurious sanctuary with our expert interior design tips.',
        author: 'Konal Biry',
        authorTitle:'Creative Director',
        create_at: '16 AUG,21',
        blogSingleImg:'/projects/maak-residence-2.jpg', 
        comment:'80',
        blClass:'format-standard-image',
        galleryImg1: '/projects/aizel-interior-1.jpg',
        galleryImg2: '/projects/7.png',
    },
    {
        id: '3',
        title: 'Decoration Apartment',
        thumb:'Architecture',
        screens: '/projects/WhatsApp Image 2025-08-08 at 12.10.43 PM.jpeg',
        description: 'Discover creative apartment decoration ideas that maximize space and reflect your personal style.',
        author: 'Aliza Anny',
        authorTitle:'Art Director',
        create_at: '18 AUG,21',
        blogSingleImg:'/projects/WhatsApp Image 2025-08-08 at 12.10.43 PM.jpeg',
        comment:'95',
        blClass:'format-video',
        galleryImg1: '/projects/4-Nos-01.jpg',
        galleryImg2: '/projects/aizel-tower-warsan-1.jpg',
    },
];
export default blog;